// extracted by mini-css-extract-plugin
export default {"pagination-buttons-container":"PaginationButtons_pagination-buttons-container__i+Z1q"};